<template>
    <AppScaffold grid>
        <Card v-if="data && !loading">
            <h1>{{ $tradFor(data.terms.name) }}</h1>
            <nav>
                <RoundedButton @click="$router.go(-1);">{{ $trad.common.cancel }}</RoundedButton>
                <RoundedButton @click="save">{{ $trad.common.save }}</RoundedButton>
            </nav>
            <table>
                <tbody>
                    <tr>
                        <td>{{ $trad.dividerEditor.width }}</td>
                        <td><NumericInput v-model="dividerConfig.width"></NumericInput></td>
                    </tr>
                    <tr>
                        <td>{{ $trad.dividerEditor.height }}</td>
                        <td><NumericInput v-model="dividerConfig.height"></NumericInput></td>
                    </tr>
                </tbody>
            </table>
        </Card>
        <Card v-else> <Loader :loading="true"></Loader> </Card>
    </AppScaffold>
</template>

<script>
import AppScaffold from "@/app-scaffold";
import TryLoad from "@/mixins/TryLoadMixin";
import componentService from "@/services/component";
import Loader from "@/components/loader/loader";
import Card from "./components/card";
import RoundedButton from "./components/rounded-button";
import NumericInput from "@/plano/components/number-input.vue";

export default {
    components: { AppScaffold, Loader, Card, RoundedButton, NumericInput },
    mixins: [TryLoad],
    data: () => ({
        data: undefined,
        dividerConfig: {
            width: 0,
            height: 0
        }
    }),
    computed: {
        dividerId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        component() {
            return (
                this.data && {
                    ...this.data,
                    config: this.dividerConfig
                }
            );
        }
    },
    created() {
        this.fetchdivider();
    },
    methods: {
        async fetchdivider() {
            this.data = await this.tryLoad(() => componentService.get(this.dividerId));
            this.dividerConfig = {
                ...this.dividerConfig,
                ...this.data.config
            };
        },
        async save() {
            try {
                await componentService.updateConfig(this.dividerId, {
                    width: Number.parseFloat(this.dividerConfig.width, 10),
                    height: Number.parseFloat(this.dividerConfig.height, 10)
                });
                this.$router.go(-1);
            } catch (err) {
                this.dialogError(err);
                throw err;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// divider-editor.vue?7af917dc